import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toHandlers as _toHandlers, mergeProps as _mergeProps, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-49010b64"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "no-margin-top title-font"
};
const _hoisted_2 = {
  class: "no-margin-top title-font"
};
const _hoisted_3 = {
  key: 0,
  class: "ion-text-center ion-margin"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "T-BIDS 2", -1));
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import appConfig from '@/app-config';
import Router, { ACTIVITIES_PATH, BRUSH_TOOL_PATH, CHAT_PATH, CONVERSATION_BANK_PATH, FIRST_STEP_ORGANIZER_PATH, HOME_PATH, LEVELS_PATH, MOOD_RATING_PATH, PLAN_PATH, REMINDERS_PATH, RESOURCES_PATH, SIBTIME_MOMENTS_PATH, USERS_PATH, VIDEOS_PATH } from '@/router';
import AppHelpLink from '@/components/AppHelpLink.vue';
import TheShellSideMenuButtons from '@/components/TheShellSideMenuButtons.vue';
import TheShellSideMenuListItem from '@/components/TheShellSideMenuListItem.vue';
import useAdminSettings from '@/composables/global/use-admin-settings';
import useCourses from '@/composables/global/use-courses';
import useShellHeader from '@/composables/global/use-shell-header';
import useViewer from '@/composables/global/use-viewer';
import { errorAlert } from '@/utils/ion-alert';
export default /*#__PURE__*/_defineComponent({
  __name: 'TheShellSideMenu',
  props: {
    contentId: {},
    mini: {
      type: Boolean
    }
  },
  setup(__props) {
    var _authUser$value$metad, _authUser$value;
    const {
      locale,
      t
    } = useI18n({
      useScope: 'global',
      messages: {
        en: {
          SideMenu: {
            joined: 'Joined',
            welcome: 'Welcome'
          }
        },
        es: {
          SideMenu: {
            joined: 'Se unió el: ',
            welcome: 'Bienvenido/a'
          }
        }
      }
    });
    const {
      featureTitles,
      featureIcons
    } = useAdminSettings();
    const {
      isOptionSet
    } = useCourses();
    const {
      backgroundColor,
      menuButtonBack
    } = useShellHeader();
    const {
      authUser,
      isGuide,
      isManager,
      isOnWeb,
      viewer
    } = useViewer();
    const creationTime = (_authUser$value$metad = (_authUser$value = authUser.value) === null || _authUser$value === void 0 ? void 0 : _authUser$value.metadata.creationTime) !== null && _authUser$value$metad !== void 0 ? _authUser$value$metad : '';
    const joinedDate = computed(() => {
      return new Date(creationTime).toLocaleDateString(locale.value);
    });
    const menuItems = computed(() => {
      var _featureTitles$value, _featureTitles$value2, _featureTitles$value3, _featureTitles$value4, _featureTitles$value5, _featureTitles$value6, _featureTitles$value7, _featureTitles$value8, _featureTitles$value9;
      return [{
        label: ((_featureTitles$value = featureTitles.value) === null || _featureTitles$value === void 0 ? void 0 : _featureTitles$value.home) || t('SideMenu.home'),
        path: HOME_PATH,
        icon: 'home',
        iconSrc: featureIcons.value.home,
        option: 'customHomePage'
      }, {
        label: ((_featureTitles$value2 = featureTitles.value) === null || _featureTitles$value2 === void 0 ? void 0 : _featureTitles$value2.users) || t('SideMenu.users'),
        path: USERS_PATH,
        icon: 'people',
        iconSrc: featureIcons.value.users
      }, {
        label: ((_featureTitles$value3 = featureTitles.value) === null || _featureTitles$value3 === void 0 ? void 0 : _featureTitles$value3.levels) || t('SideMenu.levels', 2),
        path: LEVELS_PATH,
        icon: 'layers',
        iconSrc: featureIcons.value.levels,
        isLevelItem: true
      }, {
        label: ((_featureTitles$value4 = featureTitles.value) === null || _featureTitles$value4 === void 0 ? void 0 : _featureTitles$value4.videos) || t('SideMenu.videos'),
        path: VIDEOS_PATH,
        icon: 'videocam',
        iconSrc: featureIcons.value.videos,
        option: 'userVideoUploads'
      }, {
        label: ((_featureTitles$value5 = featureTitles.value) === null || _featureTitles$value5 === void 0 ? void 0 : _featureTitles$value5.resources) || t('SideMenu.resources'),
        path: RESOURCES_PATH,
        icon: 'book',
        iconSrc: featureIcons.value.resources
      }, {
        label: ((_featureTitles$value6 = featureTitles.value) === null || _featureTitles$value6 === void 0 ? void 0 : _featureTitles$value6.chats) || t('SideMenu.chats'),
        path: CHAT_PATH,
        icon: 'chatbox',
        iconSrc: featureIcons.value.chats,
        option: 'chats'
      }, {
        label: ((_featureTitles$value7 = featureTitles.value) === null || _featureTitles$value7 === void 0 ? void 0 : _featureTitles$value7.reminders) || t('SideMenu.reminders'),
        path: REMINDERS_PATH,
        icon: 'notifications',
        iconSrc: featureIcons.value.reminders
      }, {
        label: t('SideMenu.brushTool'),
        path: BRUSH_TOOL_PATH,
        icon: 'toothbrush',
        option: 'brushTool'
      }, {
        label: t('SideMenu.moodRatings'),
        path: MOOD_RATING_PATH,
        icon: 'analytics',
        option: 'moodRatings'
      }, {
        label: t('SideMenu.activities'),
        path: ACTIVITIES_PATH,
        icon: 'sunny',
        option: 'pleasantActivities'
      }, {
        label: t('SideMenu.firstStepOrganizer'),
        path: FIRST_STEP_ORGANIZER_PATH,
        icon: 'first-step-smile',
        option: 'firstStepOrganizer'
      }, {
        label: ((_featureTitles$value8 = featureTitles.value) === null || _featureTitles$value8 === void 0 ? void 0 : _featureTitles$value8.plan) || t('SideMenu.plan'),
        path: PLAN_PATH,
        icon: 'calendar',
        iconSrc: featureIcons.value.plan,
        option: 'plan'
      }, {
        label: ((_featureTitles$value9 = featureTitles.value) === null || _featureTitles$value9 === void 0 ? void 0 : _featureTitles$value9.conversationBank) || t('SideMenu.conversationBank'),
        path: CONVERSATION_BANK_PATH,
        icon: 'mic',
        iconSrc: featureIcons.value.conversationBank,
        option: 'conversationBank'
      }, {
        label: t('SideMenu.sibTimeMoments'),
        path: SIBTIME_MOMENTS_PATH,
        icon: 'sibtime-moments',
        option: 'sibTimeMoments'
      }];
    });
    const filteredMenuItems = computed(() => {
      return menuItems.value.filter(item => {
        switch (item.path) {
          case USERS_PATH:
            return isGuide.value || isManager.value;
          case REMINDERS_PATH:
            return isOptionSet('reminders') && !isOnWeb.value;
          case RESOURCES_PATH:
            return isOptionSet('resources');
          default:
            return item.option === undefined || isOptionSet(item.option);
        }
      });
    });
    function navToRoute(path) {
      if (Router.currentRoute.value.path !== path) {
        Router.push(path).catch(error => {
          errorAlert({
            error
          });
        });
      }
    }
    return (_ctx, _cache) => {
      const _component_ion_note = _resolveComponent("ion-note");
      const _component_ion_icon = _resolveComponent("ion-icon");
      const _component_ion_col = _resolveComponent("ion-col");
      const _component_ion_row = _resolveComponent("ion-row");
      const _component_ion_grid = _resolveComponent("ion-grid");
      const _component_ion_toolbar = _resolveComponent("ion-toolbar");
      const _component_ion_header = _resolveComponent("ion-header");
      const _component_ion_list = _resolveComponent("ion-list");
      const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle");
      const _component_ion_content = _resolveComponent("ion-content");
      const _component_ion_menu = _resolveComponent("ion-menu");
      return _openBlock(), _createBlock(_component_ion_menu, {
        type: "overlay",
        contentId: _ctx.contentId,
        "swipe-gesture": !_unref(menuButtonBack)
      }, {
        default: _withCtx(() => [_createVNode(_component_ion_header, null, {
          default: _withCtx(() => [_createVNode(_component_ion_toolbar, {
            class: _normalizeClass(_ctx.mini ? 'toolbar-background' : 'menu-background'),
            style: _normalizeStyle(_ctx.mini && _unref(backgroundColor) ? `--background: ${_unref(backgroundColor)} ` : '')
          }, {
            default: _withCtx(() => [_createVNode(_component_ion_grid, {
              class: "ion-no-padding"
            }, {
              default: _withCtx(() => [_createVNode(_component_ion_row, null, {
                default: _withCtx(() => [_withDirectives(_createVNode(_component_ion_col, {
                  size: "9",
                  class: "ion-text-center ion-padding-vertical"
                }, {
                  default: _withCtx(() => {
                    var _unref2, _unref3;
                    return [_createElementVNode("h1", _hoisted_1, _toDisplayString(_unref(t)('SideMenu.welcome')) + _toDisplayString((_unref2 = _unref(viewer)) !== null && _unref2 !== void 0 && _unref2.displayName ? ',' : '.'), 1), _createElementVNode("h1", _hoisted_2, _toDisplayString((_unref3 = _unref(viewer)) === null || _unref3 === void 0 ? void 0 : _unref3.displayName), 1), _createVNode(_component_ion_note, null, {
                      default: _withCtx(() => {
                        var _unref4;
                        return [_createElementVNode("p", null, _toDisplayString((_unref4 = _unref(authUser)) === null || _unref4 === void 0 ? void 0 : _unref4.email), 1)];
                      }),
                      _: 1
                    }), _createVNode(_component_ion_note, null, {
                      default: _withCtx(() => [_createVNode(_component_ion_icon, {
                        icon: "time"
                      }), _createTextVNode(" " + _toDisplayString(_unref(t)('SideMenu.joined')) + " " + _toDisplayString(joinedDate.value), 1)]),
                      _: 1
                    })];
                  }),
                  _: 1
                }, 512), [[_vShow, !_ctx.mini]]), _createVNode(_component_ion_col, {
                  class: _normalizeClass(_ctx.mini ? 'ion-padding-horizontal' : 'margin-top'),
                  size: "3"
                }, {
                  default: _withCtx(() => [_createVNode(TheShellSideMenuButtons, _mergeProps({
                    minified: _ctx.mini
                  }, _toHandlers({
                    navToRoute: navToRoute
                  })), null, 16, ["minified"])]),
                  _: 1
                }, 8, ["class"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["class", "style"])]),
          _: 1
        }), _createVNode(_component_ion_content, {
          color: "menu"
        }, {
          default: _withCtx(() => [_createVNode(_component_ion_list, {
            class: _normalizeClass(['menu-background', {
              'safe-area-left': _ctx.mini
            }])
          }, {
            default: _withCtx(() => [_createVNode(_TransitionGroup, {
              name: "list"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMenuItems.value, item => {
                return _openBlock(), _createBlock(TheShellSideMenuListItem, {
                  key: item.path,
                  iconsOnly: _ctx.mini,
                  item: item,
                  onNavToRoute: $event => navToRoute(item.path)
                }, null, 8, ["iconsOnly", "item", "onNavToRoute"]);
              }), 128))]),
              _: 1
            })]),
            _: 1
          }, 8, ["class"]), _createVNode(_component_ion_menu_toggle, {
            "auto-hide": _ctx.mini
          }, {
            default: _withCtx(() => [_createVNode(AppHelpLink, {
              expand: "full"
            })]),
            _: 1
          }, 8, ["auto-hide"]), !_ctx.mini ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_ion_note, null, {
            default: _withCtx(() => [_hoisted_4, _createTextVNode(" (v" + _toDisplayString(_unref(appConfig).version) + ")", 1)]),
            _: 1
          })])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["contentId", "swipe-gesture"]);
    };
  }
});